export default __webpack_public_path__ + "static/media/g4.3f06f706.jpg";